import React from "react";
import { Link } from "react-router-dom";

/**
 * EP Air&Sea brand mark for EPAS Global Logistics Network.
 * variant="light"  → logo on light surface (default)
 * variant="dark"   → logo inverted to white for dark surfaces
 * size: "sm" | "md" | "lg"
 */
const SIZES = {
  sm: "h-7",
  md: "h-9",
  lg: "h-12",
};

export default function Logo({
  variant = "light",
  size = "md",
  showTagline = true,
  taglineClassName = "",
  to = "/",
  asLink = true,
  className = "",
  testId,
}) {
  const isDark = variant === "dark";
  const inner = (
    <div className={`flex items-center gap-3 ${className}`} data-testid={testId}>
      <img
        src="/ep-air-sea-logo.png"
        alt="EP Air & Sea"
        className={`${SIZES[size] || SIZES.md} w-auto ${isDark ? "logo-invert" : ""}`}
        draggable={false}
      />
      {showTagline && (
        <span
          className={`hidden sm:inline-flex flex-col leading-tight border-l ${isDark ? "border-white/20" : "border-navy/15"} pl-3 ${taglineClassName}`}
        >
          <span className={`font-display font-extrabold tracking-tight ${isDark ? "text-white" : "text-navy"} text-sm`}>EPAS</span>
          <span className={`text-[9px] uppercase tracking-[0.22em] ${isDark ? "text-white/55" : "text-navy/55"}`}>
            Global Logistics Network
          </span>
        </span>
      )}
    </div>
  );

  if (!asLink) return inner;
  return (
    <Link to={to} className="group" data-testid={testId ? `${testId}-link` : undefined}>
      {inner}
    </Link>
  );
}
